import React, { useState } from "react";
import { Breadcrumb, Dropdown } from "react-bootstrap";
import {
  FiHome,
  FiPlusCircle,
  FiFileText,
  FiChevronDown,
} from "react-icons/fi";

import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import {  Col } from 'react-bootstrap';
import AddSalaryModal from "../../modals/financial&accounts/payroll/AddSalaryModal";
export default function EmployeeSalaryHeader({ onAdd }) {

       const [showSalaryModal, setShowSalaryModal] =
    useState
    (false);
  return (
    <div className="d-md-flex d-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">



          <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Employee Salary</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                      Payroll
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Employee Salary</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>




      <div className="d-flex align-items-center flex-wrap gap-2">
        <Dropdown>
          <Dropdown.Toggle className="salary-export-btn">
            <FiFileText className="me-2" />
            Export
            <FiChevronDown className="ms-2" />
          </Dropdown.Toggle>

          <Dropdown.Menu align="end">
            <Dropdown.Item>Export as PDF</Dropdown.Item>
            <Dropdown.Item>Export as Excel</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <button
        className="salary-add-btn"
        onClick={() => setShowSalaryModal(true)}
      >
        <FiPlusCircle className="me-2" />
        Add Salary
      </button>
      </div>

      <AddSalaryModal
        show={showSalaryModal}
        handleClose={() =>
          setShowSalaryModal(false)
        }
      />
      <style>
          {
               `
               .salary-page {
  background: #f4f6f9;
  min-height: 100vh;
  padding: 24px;
}

.salary-page-title {
  font-size: 34px;
  font-weight: 700;
  color: #1e2b4d;
  margin-bottom: 8px;
}

.salary-breadcrumb {
  font-size: 14px;
}

.salary-export-btn {
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  color: #111827 !important;
  height: 46px;
  border-radius: 8px !important;
  padding: 0 18px !important;
  font-weight: 500;
}

.salary-add-btn {
  border: none;
  background: #f97316;
  color: white;
  height: 46px;
  padding: 0 22px;
  border-radius: 8px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.salary-table-card {
  background: white;
  border-radius: 14px;
  padding: 20px;
  margin-top: 20px;
}

.salary-user-img {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
}

.salary-badge {
  background: #dcfce7;
  color: #166534;
  padding: 6px 14px;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 600;
}

.salary-badge.pending {
  background: #fee2e2;
  color: #b91c1c;
}

/* Modal */

.salary-modal .modal-content {
  border-radius: 10px;
  border: none;
}

.salary-modal .modal-header {
  border-bottom: 1px solid #e5e7eb;
  padding: 20px 24px;
}

.salary-modal .modal-title {
  font-size: 28px;
  font-weight: 700;
  color: #1e2b4d;
}

.salary-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #6b7280;
  color: white;
}

.salary-input {
  height: 44px;
  border-radius: 6px !important;
  border: 1px solid #d1d5db !important;
}

.salary-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.salary-section-header h6 {
  font-size: 18px;
  font-weight: 600;
}

.salary-add-new {
  border: none;
  background: transparent;
  color: #f97316;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.salary-delete-btn {
  border: none;
  background: transparent;
  color: red;
  font-size: 18px;
}

.salary-cancel-btn {
  height: 44px;
  padding: 0 20px;
  border: 1px solid #d1d5db;
  background: white;
  border-radius: 6px;
}

.salary-submit-btn {
  height: 44px;
  padding: 0 20px;
  background: #f97316;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
}

@media (max-width: 768px) {
  .salary-page {
    padding: 14px;
  }

  .salary-page-title {
    font-size: 26px;
  }

  .salary-add-btn,
  .salary-export-btn {
    width: 100%;
    justify-content: center;
  }

  .salary-modal .modal-dialog {
    margin: 10px;
  }

  .salary-modal .modal-title {
    font-size: 22px;
  }
    .page-breadcrumb{
    flex-wrap: wrap;
    }
}
  
`
          }
      </style>
    </div>
  );
}